export default "__VITE_ASSET__92e18b2e__"